import { Box } from '@mui/material'
import { styled } from '@mui/material'

export const SmartSoftwareTitleContainer = styled(Box)(({ theme }) => ({
  width: '22.375rem',

  [theme.breakpoints.up('md')]: {
    width: '60rem',
  },

  [theme.breakpoints.up('lg')]: {
    width: '55.55rem',
  },
}))

export const CardSlider = styled(Box)<{}>(({ theme }) => ({
  overflow: 'hidden',
  display: 'flex',
  overflowX: 'auto',
  scrollBehavior: 'smooth',
  WebkitOverflowScrolling: 'touch',
  '::-webkit-scrollbar': {
    display: 'none',
  },
  webkitScrollbar: {
    display: 'none',
  },

  [theme.breakpoints.up('lg')]: {
    maxWidth: '1440px',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    boxSizing: 'border-box',
  },
}))

export const CardSliderInner = styled(Box)<{}>(({ theme }) => ({
  scrollBehavior: 'smooth',
  display: 'flex',
  overflowX: 'auto',

  [theme.breakpoints.up('lg')]: {
    display: 'grid',
    gap: '2rem',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  },
}))

export const Card = styled(Box)<{ selected?: boolean }>(({ theme, selected }) => ({
  width: '272px',
  height: '15.5rem',
  marginLeft: '1rem',
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  justifyContent: 'space-between',
  gap: '0.5rem',
  cursor: 'pointer',
  flexWrap: 'wrap',
  borderRadius: '1.5rem',
  border: `1px solid ${theme.palette.common.corporateColors.primary.white}`,
  background: selected
    ? theme.palette.common.corporateColors.primary.warmGray
    : theme.palette.common.corporateColors.primary.midNightBlue,

  '&:last-child': {
    marginRight: '1rem',
    [theme.breakpoints.up('md')]: {
      marginRight: '1.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      marginRight: '0',
    },
  },

  '&:hover': {
    background: selected ? theme.palette.common.corporateColors.primary.white : 'rgba(82, 212, 204, 0.2)',
  },

  [theme.breakpoints.up('md')]: {
    marginLeft: '1.5rem',
    width: '310px',
  },
  [theme.breakpoints.up('lg')]: {
    marginLeft: '0',
  },
}))
